module.exports = __webpack_public_path__ + "static/img/map.cb1ce2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/map.png
// module id = GJYC
// module chunks = 1